/**
 * 空调只读适配层。
 *
 * 仅使用查询接口：
 * - /api/ebc-content/airInfo/pageAir                  当前设备状态
 *
 * 禁止引入：controlAir / batchBindAir / lockAir / bathcLockAir / updateAir /
 * createAir / delete / updateBillingMode / bindTenantAir / airScheduledTask* / airGateway*。
 * 本文件不包含任何控制、下发或写操作。
 */
import request from '@/utils/request'
import { fetchDevicePages } from '../device-pages'

const AIR_PAGE_URL = '/api/ebc-content/airInfo/pageAir'
const HEADERS = { userDeviceType: 'PC', 'Content-Type': 'application/json' }
const STATUS_PAGE_SIZE = 2000
const STATUS_MAX_PAGES = 5

function post (transport, url, data) {
  return transport({
    url,
    method: 'post',
    headers: HEADERS,
    data,
    skipErrorMessage: true,
    timeout: 60000
  })
}

function successData (response) {
  if (!response || String(response.code) !== '200' || !response.data) {
    throw new Error((response && (response.msg || response.error)) || '空调数据请求失败')
  }
  return response.data
}

/** 分页取全量设备；超出上限时保留已取部分并标记 truncated。 */
async function fetchAllRows (transport, url, baseData, pageSize, maxPages) {
  return fetchDevicePages(async page => successData(await post(transport, url, { ...baseData, page })), { pageSize, maxPages })
}

export function createAcApi (transport = request) {
  return {
    /** 空调设备状态快照（按项目）。 */
    async status (projects = []) {
      const entries = []
      for (const project of projects) {
        const id = String(project.id)
        try {
          const { rows, total, truncated } = await fetchAllRows(
            transport,
            AIR_PAGE_URL,
            { managerId: Number(id) },
            STATUS_PAGE_SIZE,
            STATUS_MAX_PAGES
          )
          entries.push({ id, rows, total, ok: true, truncated })
        } catch (error) {
          entries.push({ id, rows: [], total: null, ok: false, error: error && error.message })
        }
      }
      return entries
    }
  }
}
